const apiConfigs = {
  "regional": {
    "apiHost": "https://api-dev.mit.edu",
    "paths": {
      "apiPathDigitalId": "digital-id-v1",
      "apiPathFinance": "finance-v3",
      "apiPathAccount": "account-v2",
      "apiPathFeature": "feature-v1"
    }
  },
  "global": {
    "apiHost": "https://sponsored-accounts-v2.atlas-apps-dev.mit.edu/api",
    "paths": {
      "apiPathDigitalId": "digital-id/v1",
      "apiPathFinance": "finance/v3",
      "apiPathAccount": "account/v2",
      "apiPathFeature": "feature/v1"
    }
  }
};
export default apiConfigs;